<template>
  <section>
    <PvCard class="mb-2">
      <template #title>
        <slot name="title">
          <h2 class="mb-3">{{ sectionCaption }}</h2>
        </slot>
      </template>
      <template #content>
        <slot name="content"></slot>
      </template>
    </PvCard>  
  </section>
</template>

<script setup>
defineProps({
  sectionCaption: {
      type: String,
      default: 'Section Caption'
  }
});
</script>
